import { render, staticRenderFns } from "./PopulationPanels.vue?vue&type=template&id=90d3a7b6"
import script from "./PopulationPanels.vue?vue&type=script&lang=js"
export * from "./PopulationPanels.vue?vue&type=script&lang=js"
import style0 from "./PopulationPanels.vue?vue&type=style&index=0&id=90d3a7b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports